module.exports = __webpack_public_path__ + "img/calculator.8bbd4362.png";